import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='M14.856 7.798 12.21 5.154l2.645-2.644L17.5 5.154zm5 3L18.21 9.154l1.645-1.644L21.5 9.154zM12.075 21.5a9.3 9.3 0 0 1-3.74-.757 9.7 9.7 0 0 1-3.047-2.056 9.7 9.7 0 0 1-2.056-3.047 9.3 9.3 0 0 1-.757-3.74q0-3.285 2.003-5.851t5.18-3.366a10.5 10.5 0 0 0 .496 4.669 10.25 10.25 0 0 0 2.49 3.979 10.25 10.25 0 0 0 3.979 2.49q2.262.773 4.67.496-.785 3.177-3.36 5.18Q15.36 21.5 12.075 21.5m0-1.5a7.9 7.9 0 0 0 4.075-1.1 7.9 7.9 0 0 0 2.95-3.025 12.3 12.3 0 0 1-4.075-1.092 12 12 0 0 1-3.45-2.417A12.1 12.1 0 0 1 9.15 8.92a11.8 11.8 0 0 1-1.075-4.07 7.8 7.8 0 0 0-3.012 2.963A8.05 8.05 0 0 0 3.975 11.9q0 3.376 2.363 5.737Q8.699 20 12.075 20'
    />
  </svg>
)
export default SvgComponent
